import Component from '../component/component';

import './timer.scss';

export default class Timer extends Component {
    static initSelector: string = '.js-timer';

    duration: number;

    constructor(target: HTMLElement) {
        super(target);

        this.duration = parseInt(this.element.getAttribute('data-duration'));

        this.init();
    }

    init(): void {
        this.calculateRemainingTime();
    }

    calculateRemainingTime(): void {
        const timerInterval: number = window.setInterval(() => {
            this.duration -= 1;
            this.changeTime(this.duration);

            if (this.duration === 0) {
                clearInterval(timerInterval);
            }
        }, 1000);
    }

    changeTime(value: number): void {
        const minutes: number = Math.floor(value / 60);
        const seconds: number = value - minutes * 60;

        const minutesString: string = ('0' + minutes.toString()).slice(-2);
        const secondsString: string = ('0' + seconds.toString()).slice(-2);

        this.element.innerText = (minutesString + ':' + secondsString);
    }
}
